// ฟังก์ชันสำหรับบทบาท (Roles)
export const tagsBage = (i) => {
  switch (i) {
    case "SuperOwner":
      return "purple";
    case "Owner":
      return "magenta";
    case "Subowner":
      return "default";
    case "Finance":
      return "cyan";
    case "Administrators":
      return "volcano";
    default:
      return "default";
  }
};

// ฟังก์ชันสำหรับสถานะการแจ้งเตือน (Alert Statuses)
export const tagsAlertBage = (i) => {
  switch (i) {
    case "PENDING":
      return "warning";

    case "expired":
    case "REJECTED":
    case "VERRIFY_FAILED":
      return "error";

    case "SUCCESS":
      return "success";

    case "PROCESSING":
      return "info";

    case "IN_QUEUE":
      return undefined;
    default:
      return undefined;
  }
};

// ฟังก์ชันสำหรับประเภทการทำรายการ (Transaction Types)
export const tagsTypeBage = (i) => {
  switch (i) {
    case "deposit":
      return "success";
    case "HIGH":
    case "withdrawal":
    case "withdraw": // รวม withdrawal และ withdraw
      return "error";
    case "verifying_account":
      return "processing";
    case "MEDIUM":
      return "warning";
    default:
      return "default";
  }
};

// ฟังก์ชันสำหรับสีประเภทการทำรายการ (Transaction Type Colors)
export const tagsTypeBageColor = (i) => {
  switch (i) {
    case "deposit":
    case "DEPOSIT":
      return "#52c41a";
    case "withdrawal":
    case "WITHDRAW":
    case "withdraw": // รวม withdrawal และ withdraw
      return "#ff4d4f";
    case "verifying_account":
    case "BANK_ACCOUNT":
      return "rgb(22, 119, 255)";

    case "DEPOSIT_WITHDRAW":
      return "#642ab5";
    default:
      return "#888";
  }
};

// ฟังก์ชันสำหรับสีมิเตอร์ (Meter Colors)
export const tagsColorMeter = (i) => {
  switch (i) {
    case "Fast":
      return "#52c41a";
    case "Medium":
      return "#faad14";
    case "Bad":
      return "#ff4d4f";
    default:
      return "default";
  }
};

// ฟังก์ชันสำหรับสีการแจ้งเตือน (Alert Colors)
export const tagsColorAlert = (i) => {
  switch (i) {
    case "success":
    case "SUCCESS":
      return "#52c41a";
    case "purple":
    case "IN_QUEUE":
      return "#531dab";
    case "info": // รวม info และ purple
    case "PROCESSING":
      return "#0958d9";
    case "warning":
    case "PENDING":
      return "#faad14";
    case "error":
    case "not_found":
    case "REJECTED":
      return "#ff4d4f";
    case "geekblue":
    case "VERRIFY_FAILED":
      return "#1d39c4";
    default:
      return "default";
  }
};

// ฟังก์ชันสำหรับสีสถานะที่ซับซ้อน (Complex Status Colors)
export const tagsBageStatus = (i) => {
  // เพื่อจัดการกับการเปรียบเทียบ String/Number และกรณีพิมพ์ใหญ่/เล็ก ควรใช้ .toString().toUpperCase()
  const status = typeof i === "string" ? i.toUpperCase() : i;

  switch (status) {
    // สถานะที่เป็นตัวเลข
    case 1:
    case "ACTIVE":
    case "MATCHED":
    case "SUCCESS":
    case "success":
    case "OPEN":
    case "READY":
      return "rgb(82, 196, 26)"; // Success-like color

    case 0:
    case "DELETE":
    case "INACTIVE":
    case "EXPIRED":
    case "REJECTED":
    case "ERROR":
    case "FAILED":
    case "NOT_MATCH":
    case "NOT_FOUND":
      return "rgb(245, 34, 45)"; // Error-like color

    // สถานะที่ใช้ชื่อสี (Ant Design หรือคล้ายกัน) REQUESTING
    case "DEPOSIT":
    case "deposit":
      return "success";

    case "WITHDRAWAL":
    case "withdrawal":
    case "WITHDRAW":
    case "WITHDRAWALMANUAL":
      return "error";

    case "PENDING":
    case "pending":
    case "CUSTOMER REPLY":
    case "CHECKING":
    case "PENDINGDEVICE":
    case "LOGINQR":
    case "MAINTENANCE":
      return "#faad14";

    case "PROCESSING":
    case "ONHOLD":
      return "rgb(62, 172, 255)";

    case "verifying_account":
    case "VERIFYING_ACCOUNT":
      return "processing";

    case "IN_QUEUE":
    case "DUPLICATED":
    case "VAULT":
      return "#531dab";

    case "VERRIFY_FAILED":
      return "#1d39c4";

    case "INQ_MANUAL":
    case "Manual":
      return "#08979c";

    default:
      return "default";
  }
};

// ฟังก์ชันสำหรับสีตามยอดคงเหลือ (Balance Color Tiers)
export const tagsColorBalance = (i) => {
  if (i >= 1000000) {
    return "#673ab7";
  } else if (i >= 100000) {
    return "#9f00ff";
  } else if (i >= 10000) {
    return "#1677ff";
  } else if (i >= 100) {
    return "#fd7e14";
  } else if (i >= 0) {
    return "rgb(245, 34, 45)";
  } else {
    // กรณีที่ i เป็นค่าติดลบ
    return "";
  }
};

// ฟังก์ชันสำหรับสีตามขีดจำกัดคงเหลือ (Limit Left Color Tiers)
// ฟังก์ชันนี้เหมือนกับ tagsColorBalance ผมจึงรักษาไว้ตามเดิม
export const tagsColorLimitLeft = (i) => {
  if (i >= 1000000) {
    return "#673ab7";
  } else if (i >= 100000) {
    return "#9f00ff";
  } else if (i >= 10000) {
    return "#1677ff";
  } else if (i >= 100) {
    return "#fd7e14";
  } else if (i >= 0) {
    return "rgb(245, 34, 45)";
  } else {
    // กรณีที่ i เป็นค่าติดลบ
    return "";
  }
};
